<template>
  <div class="moderation-container">

    <div class="breaking_news--container" v-if="this.mText == 'Breaking news'">
      <div class="moderation--img bn-img">
        <img src="../../assets/moderation/moderation_comment_sheet.svg" />
      </div>
      <lottie-player
      class="lottie-player"
      autoplay
      loop
      count=3
      mode="normal"
      :src="breakingJSON">
      </lottie-player>
    </div>
    <div class="moderation--container">
      <div class="moderation--img" 
        v-if="
          this.mText == 'Under community moderation' ||
          this.mText == 'Community moderated' ||
          this.mText == 'Breaking news' ||
          this.mText == 'Popular'
        "
      >
        <img src="../../assets/moderation/moderation_comment_sheet.svg" />
      </div>
      
      <div :class="this.moderationClass">
          <div class="controversial-img" v-if="this.mText == 'Controversial'">
            <img src="../../assets/moderation/moderation_comment_sheet.svg" />
          </div>
          <div class="controversial--container" v-if="this.mText == 'Controversial'">
                <lottie-player
                  v-if="this.mText == 'Controversial'"
                  class="lottie-player"
                  autoplay
                  loop
                  mode="normal"
                  :src="contJSON">
                </lottie-player>
                <p v-if="this.mText == 'Controversial'">
                    {{ this.mText }}
                </p>
          </div>

          <lottie-player
            v-if="this.mText == 'Popular'"
            class="lottie-player"
            autoplay
            loop
            mode="normal"
            :src="popJSON">
            </lottie-player>

          <p v-if="this.mText == 'Under community moderation' ||
          this.mText == 'Community moderated' ||
          this.mText == 'Popular'">
            {{ this.mText }}
          </p>
      </div>
    </div>
  </div>
</template>


<script>
import popularJSON from '../../assets/moderation/popluar_flame.json';
import controversialJSON from '../../assets/moderation/controversial.json';
import breakingNewsJson from '../../assets/moderation/breaking-news.json';

const ModerationText = {
  UNDER_COMMUNITY_MODERATION: "Under community moderation",
  COMMUNITY_MODERATED: "Community moderated",
  Popular: "Popular",
  Breaking_News: "Breaking news",
  Controversial: "Controversial",
};

const ModerationActions = {
  MARK_POST_AS_POPULAR: 4,
  MARK_POST_AS_FAKE: 7,
};

const UhiveInterests = {
  News_And_Politics: 5,
};

const ModerationStatus = {
  NONE: 1,
  UNDER_MODERATION: 2,
  MODERATED: 3,
};

export default {
  name: "Moderation",
  data() {
    return {
      mText: '',
      moderationClass: '',
      popJSON: JSON.stringify(popularJSON),
      contJSON: JSON.stringify(controversialJSON),
      breakingJSON: JSON.stringify(breakingNewsJson)
    };
  },
  props: {
    interestId: {
      type: Number,
    },
    moderationStatus: {
      type: Number,
    },
    moderationSummary: {
      type: Object,
    },
  },
  methods: {
    getModerationDominantAction(moderationSummary) {
      var isPopularPost = false;
      for (let i = 0; i < moderationSummary.actions.length; i++) {
        var action = moderationSummary.actions[i];
        if (action.action == ModerationActions.MARK_POST_AS_FAKE)
          return ModerationActions.MARK_POST_AS_FAKE;
        else if (action.action == ModerationActions.MARK_POST_AS_POPULAR)
          isPopularPost = true;
      }

      if (isPopularPost) return ModerationActions.MARK_POST_AS_POPULAR;
      else return null;
    },
    moderationTextM() {
      // Actions and status Priority
      // 1- Fake
      // 2- Popular
      // 3- Moderated Or Under Moderation
      
      var moderationAction = this.moderationSummary ? this.getModerationDominantAction(
        this.moderationSummary
      ): null ;
      console.log(moderationAction);
      if (moderationAction == ModerationActions.MARK_POST_AS_FAKE) {
        this.mText = ModerationText.Controversial;
        this.moderationClass = 'controversial';
      } else if (moderationAction == ModerationActions.MARK_POST_AS_POPULAR) {
        if (this.interestId == UhiveInterests.News_And_Politics){
          this.mText = ModerationText.Breaking_News;
          this.moderationClass = 'breaking-news';
        }else {
          this.mText = ModerationText.Popular;
          this.moderationClass = 'popular';
          this.moderationClass = 'popular';
        }
      } else {
        if (this.moderationStatus == ModerationStatus.MODERATED) {
          this.mText = ModerationText.COMMUNITY_MODERATED;
          this.moderationClass = 'community';
        } else if (this.moderationStatus == ModerationStatus.UNDER_MODERATION) {
          this.mText = ModerationText.UNDER_COMMUNITY_MODERATION;
          this.moderationClass = 'community_moderation';
        }
      }
    },
  },
  mounted() {
    this.moderationTextM()
  }
};
</script>


<style scoped>
@supports (-webkit-touch-callout: none) and (not (translate: none)) {
    .moderation--container{
      height: fit-content !important;
    }
}

.controversial {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 12rem;
  height: 3.5rem;
  margin: 8px 231px 30px 0;
  padding: 0.5rem 0.2rem 0.5rem 0;
  flex-direction: row;
  border: 1px solid transparent;
  border-radius: 0.3rem;
}
.controversial--container{
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 10rem;
  height: 2rem;
  background-color: #4289ff;
  border: 1px solid transparent;
  border-radius: 0.3rem;
}
.controversial-img{
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 72%;
  height: 95%;
  background-color: #413f43;
  border: 1px solid transparent;
  border-radius: 50%;
  margin-right: 0.4rem;
}
.controversial-img img{
  width: 60%;
  height: 64%;
  padding: 0;
}
.controversial lottie-player{
    height: 1.5rem;
    width: 1.5rem;
    margin-top: 0.2rem;
    margin-right: 0.2rem;
    margin-left: 0.4rem;
}
.moderation--container{
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  height: 2rem;
  border: 1px solid transparent;
  border-radius: 0.3rem;
}
.moderation--img{
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background-color: rgba(0, 0, 0, 0.6);
  border: 1px solid transparent;
  border-radius: 50%;
  margin-right: 0.4rem;
}
.moderation--img img{
  width: 60%;
  height: 64%;
  padding: 0;
}
.controversial lottie-player{
    height: 1.5rem;
    width: 1.5rem;
    margin-top: 0.2rem;
    margin-right: 0.2rem;
    margin-left: 0.4rem;
}
.controversial p{
  color: #fff;
  margin-right: 0.8rem;
}
.popular{
  display: flex;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  width: 7rem;
  height: 2rem;
  margin: 0;
  flex-direction: row;
  background-color: #eba727;
  border: 1px solid transparent;
  border: 1px solid transparent;
  border-radius: 0.3rem;
}
.popular lottie-player{
  width: 2rem;
  height: 100%;
} 
.popular {
  color: #fff;
}
.community, .community_moderation{
  display: flex;
  align-content: center;
  justify-content: center;
  width: 10rem;
  height: 2rem;
  /* margin: 0px 231px 0px 2px; */
  padding: 0.5rem 0.2rem 0.5rem 0.2rem;
  background-color: rgba(0, 0, 0, 0.6);
  flex-direction: row;
  border: 1px solid transparent;
  border-radius: 0.3rem;
}
.community_moderation{
  width: 13rem;
  margin-left: 0;
}
.community_img--container{
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
  margin: 8px 0 30px 2px;
  padding: 0.5rem 0.2rem 0.5rem 0.2rem;
  width: 2rem;
  height: 2rem;
  background-color: rgba(0, 0, 0, 0.6);
  border: 1px solid transparent;
  border-radius: 50%;
}
.community_img--container img {
  width: 1.2rem !important;
}
.community p, .community_moderation p {
  font-size: 0.8rem;
  font-family: SFUIDisplay;
  font-weight: 600;
  letter-spacing: -0.16px;
  text-align: left;
  color: #fff;
}
.breaking_news--container{
  position: relative;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 12rem;
  margin: 8px 231px 30px 2px;
  padding: 0.5rem 0.2rem 0.5rem 0.2rem;
}
.bn-img{
  width: 2.3rem;
  margin-top: 0.6rem;
}
p {
  word-wrap: break-all;
}
.moderation-container {
  display: flex;
  z-index: 920;
  gap: 0.5rem;
  align-items: center;
}
.moderation-container img {
  width: 1.6rem;
}
.location-container p {
  font-size: 0.8rem;
  padding: 0;
  margin: 0;
}
</style>